const injection = { asd: "asd" };

export default injection;
